import React, { useState } from 'react';
import './VillainSelector.css';

const VillainSelector = ({ villainCategories, onSelect, selectedVillain }) => {
    // Estado para controlar si se muestra la imagen frontal o la trasera
    const [showBackImage, setShowBackImage] = useState(false);
    const [imageNumber, setImageNumber] = useState(0); // Estado para controlar el número de la imagen actual

    const handleImageClick = () => {
        // Alterna entre la imagen frontal y la trasera
        setShowBackImage(!showBackImage);
    };

    const getUrlImageTirano = (imgNumber) => {
        if (!selectedVillainObject) return null;

        return 'https://firebasestorage.googleapis.com/v0/b/tmbcards-3ec94.appspot.com/o/tiranos%2Ftirano_'+selectedVillainObject.clave+'_'+selectedVillainObject.keyname+'_'+imgNumber;
    }

    const getVillainImage = (imgNumber) => {
        if (!selectedVillainObject) return null;

        // Usa la imagen trasera si showBackImage es verdadero
        return !showBackImage ? getUrlImageTirano(imgNumber)+'_frontal.jpg?alt=media': getUrlImageTirano(imageNumber)+'_trasera.jpg?alt=media';
        console.log(imageNumber);
    };

    // Encontrar el objeto del villano seleccionado
    const selectedVillainObject = villainCategories
        .flatMap(category => category.villains)
        .find(villain => villain.name === selectedVillain);

    // Verificar si la propiedad cartaExtra es igual a 1
    const showVillainControls = selectedVillainObject && selectedVillainObject.cartaExtra > 0;

    const handlePreviousCard = () => {
        setImageNumber((prevNumber) => (prevNumber > 0 ? prevNumber - 1 : prevNumber)); //Decrementa hasta 0
    };
    
    const handleNextCard = () => {
        setImageNumber((prevNumber) => (prevNumber < selectedVillainObject.cartaExtra ? prevNumber + 1 : prevNumber)); //Incrementa hasta 1
    };

    return (
        <div className="villain-selector-container">
            <h3>Selecciona un villano</h3>
            <div className="villain-selector">
                <div className="villain-categories">
                    {villainCategories.map((category) => {
                        // Verifica si la categoría actual contiene el villano seleccionado
                        const isSelectedCategory = category.villains.some(villain => villain.name === selectedVillain);

                        return (
                            <button
                                key={category.category}
                                className={`category-button ${isSelectedCategory ? 'selected' : ''}`}
                                onClick={() => onSelect(category.villains[0].name)}
                            >
                                {category.category}
                            </button>
                        );
                    })}
                </div>

                <div className="villain-list-container">
                    {villainCategories.find(cat => cat.villains.some(villain => villain.name === selectedVillain)) && (
                        <div className="villain-list">
                            {villainCategories.find(cat => cat.villains.some(villain => villain.name === selectedVillain)).villains.map((villain) => (
                                <button
                                    key={villain.name}
                                    className={`villain-button ${selectedVillain === villain.name ? 'selected' : ''}`}
                                    onClick={() => onSelect(villain.name)}
                                >
                                    {villain.name}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="villain-image-container">
                {selectedVillain && (
                    <>
                        <img
                            src={getVillainImage(imageNumber)}
                            alt={selectedVillain}
                            className="villain-image"
                            onClick={handleImageClick}
                        />
                        <p className="image-note">Haz click sobre la imagen para ver su parte trasera</p>
                    </>
                )}
            </div>

            {showVillainControls && (
                <div className="villain-controls-container">
                    <div className="villain-controls">
                        <button onClick={handlePreviousCard} className="day-button"> &lt; </button> 
                        <button onClick={handleNextCard} className="day-button"> &gt; </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VillainSelector;
